import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MessageService } from 'primeng/api';
import { MerchantService } from 'app/services';
import { RejectReasonEnum, DocumentStatusEnum } from 'app/models';
import moment from 'moment';

enum ForApproveMenuEnum {
    SEC = 1,
    BIR = 2,
    PersonalId = 3,
    Fees = 4
}
enum FeeType {
    Percentage = 1,
    Peso = 2
}

@Component({
    selector: 'approve-docs-mart-partner',
    templateUrl: './approve-docs-mart-partner.component.html',
    styleUrls: ['./approve-docs-mart-partner.component.scss'],
    providers: [MessageService],
})
export class ApproveDocsMartPartnerComponent implements OnInit {

    constructor(private merchantService: MerchantService,
        private messageService: MessageService) { }
    ngOnInit() {
        this.getMerchantDocs();
    }
    @Input()
    public merchant: any;

    @Input()
    public onHide: () => void = () => { };

    public showApproveMartPartner: boolean = true;
    public activeTab: ForApproveMenuEnum = ForApproveMenuEnum.SEC;
    public approveMenuTab = ForApproveMenuEnum;
    public feeTypes: any[] = [{ name: 'Percentage', id: FeeType.Percentage }, { name: 'Peso', id: FeeType.Peso }];

    public secCompNameIsCorrect: boolean = false;
    public secDocsIsLegible: boolean = false;
    public birCompNameIsCorrect: boolean = false;
    public birDocsIsLegible: boolean = false;
    public personalIdNameIsCorrect: boolean = false;
    public personalIdIsReadable: boolean = false;
    public personalIdIsActually: boolean = false;
    public personalIdIsLegible: boolean = false;
    public companyTin: string = '';
    public compRegistrNumber: string = '';
    public birDateIssue: Date | undefined = undefined;
    public selectedServiceFee: any;
    public amountFee: number | undefined = undefined;

    public rejectReason: string = '';
    public showRejectPopup: boolean = false;
    currentDay: Date = new Date();

    public getMerchantDocs() {
        const dto = {
            MerchantId: this.merchant.Id
        };
        this.merchantService.getMerchantDocuments(dto, this.messageService).then(data => {
            if (!data) {
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.merchant.birImageUrl = data.BIR2303DocumentImageUrl;
            this.merchant.secImageUrl = data.SECDocumentImageUrl;
            this.merchant.personalIdImageUrl = data.PersonalIdentificationImageUrl;
            this.merchant.businessName = data.BusinessName;
            this.merchant.userName = data.UserName;
        });
    }

    public close() {
        this.onHide();
    }

    public nextTab(tab: ForApproveMenuEnum) {
        this.activeTab = tab;
    }

    public rejectApplication() {
        const dto = {
            RejectReason: this.rejectReason,
            MerchantId: this.merchant.Id,
            RejectReasonId: RejectReasonEnum.RejectDocument,
            SECDocumentStatusId: (this.activeTab === ForApproveMenuEnum.SEC) ? DocumentStatusEnum.Rejected : DocumentStatusEnum.UnderReview,
            BIR2303DocumentStatusId: (this.activeTab === ForApproveMenuEnum.BIR) ? DocumentStatusEnum.Rejected : DocumentStatusEnum.UnderReview,
            PersonalIdentificationStatusId: (this.activeTab === ForApproveMenuEnum.PersonalId) ? DocumentStatusEnum.Rejected : DocumentStatusEnum.UnderReview
        };
        this.merchantService.rejectMerchantApplication(dto, this.messageService).then(data => {
            if (!data) {
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Application rejected.' });
            this.showRejectPopup = false;
            this.close();
        });
    }

    public showRejectPopupHandle() {
        this.showRejectPopup = true;
    }

    public approveMerchantDocs() {
        if (this.selectedServiceFee.id === 1 && this.amountFee !== undefined && this.amountFee > 100) {
            this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Percentages cannot be greater than 100' });
            return;
        }
        const dto = {
            MerchantId: this.merchant.Id,
            Tin: this.companyTin,
            RegNumber: this.compRegistrNumber,
            BirDateIssue: moment(this.birDateIssue).format('YYYY-MM-DDT00:00:00'),
            TypeServiceFee: this.selectedServiceFee.id,
            ServiceFee: this.amountFee
        };

        this.merchantService.approveMerchantDocs(dto, this.messageService).then(data => {
            if (!data) {
                return;
            }

            if (!data.Success) {
                this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                return;
            }
            this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Application Approved.' });

            this.close();
        });
    }
}
